<div class="d-flex" *ngFor="let priceLine of inputList; let index = index">
  <price-line-input
    class="flexer-19"
    [priceLine]="priceLine"
    [alignWithBoardPrices]="alignWithBoardPrices"
    (output)="priceLineChanged($event, index)"
  ></price-line-input>
  <div class="flexer box clickable" (click)="deleteLine(index)">
    <mat-icon svgIcon="close"></mat-icon>
  </div>
</div>

<div>
  <button
    class="plus-button button"
    (click)="addLine()"
    type="button"
    mat-button
  >
    <mat-icon svgIcon="white-plus"></mat-icon>
  </button>
  <ng-container *ngIf="showSave">
    <button
      *ngIf="!savingLines; else loading"
      class="button save-button"
      (click)="savePrices()"
      type="button"
      mat-button
    >
      Sla prijsberekeningen op
    </button>

    <ng-template #loading>
      <mat-spinner
        class="save-spinner"
        color="primary"
        diameter="24"
      ></mat-spinner>
    </ng-template>
  </ng-container>
</div>
